var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:none;stroke:#1d1d1b;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.7px}"))), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: "1.98px",
      stroke: "#1d1d1b",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    },
    d: "M78.31 19.79h66.54v120.67H14.72V19.79H37.6"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.09 42v30.95L38.47 126.1a2.23 2.23 0 0 0 2.22 2.22h63.08a2.23 2.23 0 0 0 2.23-2.22L79.38 73V42M82.5 41.25H61.96M82.12 96.35H74.1M78.99 102.9H74.1M78.99 89.8H74.1M82.12 109.46H74.1M78.99 116.01H74.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.87 61.94a26.3 26.3 0 1 1 19.95 46.26"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109 62.92a19.33 19.33 0 0 1 11.1 15.17",
    style: {
      fill: "#fff",
      strokeWidth: "1.7px",
      stroke: "#1d1d1b",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.27 49.51a15.86 15.86 0 0 1-18.13-13.39A16.13 16.13 0 0 1 55.26 17.6 15.86 15.86 0 0 1 73.39 31a16.39 16.39 0 0 1-.08 5.64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.74 21.73a12.1 12.1 0 0 1 8.83 9.89"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlask);
export default __webpack_public_path__ + "static/media/flask.fc40adc6.svg";
export { ForwardRef as ReactComponent };